(function () {
  function initProductCarousel(scope = document) {
    const carousels = scope.querySelectorAll('[data-product-carousel]');

    carousels.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      if (typeof Swiper === 'undefined') return;

      const swiperEl = root.querySelector('[data-product-carousel-swiper]');
      const paginationEl = root.querySelector('[data-product-carousel-pagination]');

      if (!swiperEl) return;

      root.dataset.initialized = 'true';

      new Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 12,
        speed: 500,
        watchOverflow: true,
        pagination: {
          el: paginationEl,
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} block h-2.5 w-2.5 rounded-full bg-black/20 transition-all duration-200"></span>`;
          }
        },
        breakpoints: {
          750: {
            slidesPerView: 1.5,
            spaceBetween: 12
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 12
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 12
          }
        }
      });
    });
  }

  window.initProductCarousel = initProductCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductCarousel(), { once: true });
  } else {
    initProductCarousel();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductCarousel(event.target);
  });
})();